/**
 * 界面修正补丁
 * 2018-03-28
 * Bai.Zhiming
 */
"use strict";
angular.module("pageFixPatchModule", ['leftAutoHeightModule', 'leftLiWidthModule', 'trsHeightModule', 'listAutoHeightModule', 'trsScrollbarModule', 'trsHeightsModule', 'trsLeftModule', "mouseWheelShowMoreModule", "getHeightModule"]);